import React from 'react';

import { Typography } from '@mui/material';

import { getProseStatus } from './formatters';
import { getStatusBodyText } from './getStatusBodyText';
import type { DisplayChange } from './types';

interface ChangeSummaryProps {
  change: DisplayChange;
  showPrevious: boolean;
}

function getFullSummary(change: DisplayChange): string | undefined {
  if (Array.isArray(change.prev) || Array.isArray(change.next)) {
    return change.summary;
  }

  return undefined;
}

export default function ChangeSummary({ change, showPrevious }: ChangeSummaryProps) {
  const statusBodyText = getStatusBodyText(change);

  if (statusBodyText) {
    return (
      <Typography variant="body2" sx={{ overflowWrap: 'anywhere' }}>
        {statusBodyText}
      </Typography>
    );
  }

  const summary = change.isLongText
    ? showPrevious
      ? getProseStatus(change.prev, change.summary)
      : change.summary
    : getFullSummary(change);

  if (!summary) {
    return null;
  }

  return (
    <Typography variant="caption" color="text.secondary" fontWeight={700}>
      {summary}
    </Typography>
  );
}
